import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeaker32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSpeaker32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.752 13H6v6h4.752l.565.495L16 23.593V8.408l-4.683 4.097zM6 11a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4l6.342 5.549c.646.566 1.658.107 1.658-.753V6.204c0-.86-1.012-1.318-1.658-.753L10 11.001zm14.202-.113a1 1 0 0 1 1.4-.195L21 11.49l.603-.797h.001l.002.002.004.003.01.008.102.083-.062-2.772.062 2.772.017.014a6.6 6.6 0 0 1 1.094 1.264A7.03 7.03 0 0 1 24 16c0 1.734-.58 3.051-1.167 3.933a6.6 6.6 0 0 1-.88 1.068l.059 2.636.023-.013.112-.07c.102-.067.254-.173.441-.318.375-.293.88-.743 1.387-1.364C24.984 20.64 26 18.73 26 16s-1.015-4.64-2.02-5.873a8.8 8.8 0 0 0-1.384-1.363 7 7 0 0 0-.552-.388l-.023-.014h-.002a1 1 0 0 1-.359-.345l-.023-1.015a1 1 0 0 1 1.361-.385l-.488.873c.488-.873.488-.873.489-.872l.003.002.006.003.017.01a4 4 0 0 1 .226.14c.143.094.342.232.576.415.469.366 1.086.919 1.703 1.675C26.77 10.385 28 12.73 28 16c0 3.272-1.233 5.616-2.476 7.138a10.8 10.8 0 0 1-1.706 1.675 9 9 0 0 1-.752.524l-.052.031-.017.01-.006.003-.002.001h-.001l-.488-.872.487.873a1 1 0 0 1-.977-1.744l-.06-2.636a5 5 0 0 1-.3.268l-.03.023-.01.008-.004.004-.002.001c-.001 0-.002.001-.604-.797l.602.798a1 1 0 0 1-1.21-1.592l.003-.003.038-.031q.057-.048.17-.16a4.6 4.6 0 0 0 .564-.695c.27-.406.542-.946.698-1.624l-.058-2.637a5 5 0 0 0-.64-1.392 4.6 4.6 0 0 0-.563-.696 3 3 0 0 0-.171-.16q-.027-.024-.038-.031l-.003-.003a1 1 0 0 1-.19-1.397m1.605 3.683.06 2.628c.083-.36.133-.76.133-1.198 0-.535-.075-1.011-.192-1.43m-.147-6.553a1 1 0 0 1-.023-1.015zm.846-.52c-.484.866-.484.866-.485.865h.001z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeaker32);
